import { isNewPpi, isUpdatedPpi } from '../ppi/status';

function decoratePpis(ppis = [],dateDuration=14) {
  return ppis.map(ppi => {
    const isNew = isNewPpi(ppi,dateDuration);
    const isUpdated = isUpdatedPpi(ppi,dateDuration);
    return {
      ...ppi,
      isNew,
      isUpdated
    };
  });
}

export default decoratePpis;
